


















































import { Vue, Component, Mixins } from 'vue-property-decorator';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import GoBackWithCloseTabMixin from '@/common/mixins/go-back-with-close-tab';
import * as api from '../../../api/reconciliation-management';
import { API_SERVER } from '@/common/config';

@Component
export default class CashPageDetail extends Mixins(TableMixin, TableWidthMixin, GoBackWithCloseTabMixin) {
  // 是否冲销
  cancel: boolean = false;
  // 冲销原型，只在冲销状态下填写
  cancelReason: string = '';
  // 面包屑
  get navs() {
    return [
      {
        label: '存现单管理',
        location: {
          name: 'cash-page'
        }
      },
      {
        label: this.$route.meta.title
      }
    ];
  }

  depositId: string = '';
  detailModel: any = {};
  detailFields: any[] = [
    {
      prop: 'bankReceiptNo',
      label: '银行回单'
    },
    {
      prop: 'receiptTime',
      label: '回单日期'
    },
    {
      prop: 'amounts',
      label: '回单金额',
      render: function(h: (arg0: string, arg1: {}, arg2: string[]) => any, params: { data: { amounts: number } }) {
        const m = (params.data.amounts / 100).toFixed(2) + '元';
        return h('span', {}, [m]);
      }
    },
    {
      prop: 'parkName',
      label: '车场名称'
    },
    {
      prop: 'bankNo',
      label: '银行账号'
    },
    {
      prop: 'remark',
      label: '备注',
      render(
        h: (arg0: string, arg1: { attrs?: { placement: string; title: any }; class?: string }, arg2: any[]) => any,
        params: { data: { remark: any } }
      ) {
        return h(
          'a-tooltip',
          {
            attrs: {
              placement: 'topLeft',
              title: params.data.remark
            }
          },
          [
            h(
              'div',
              {
                class: 'text-ellipse'
              },
              params.data.remark || '-'
            )
          ]
        );
      }
    },
    {
      prop: 'depositId',
      label: '存现单号'
    },
    {
      prop: 'createTime',
      label: '创单日期'
    },
    {
      prop: 'cancelDepositId',
      label: '关联单号'
    },
    {
      prop: 'attachFileUrl',
      label: '附件',
      render: function(
        h: (arg0: string, arg1: { attrs: { href: any; target: string } }, arg2: string[]) => any,
        params: { data: { attachFileUrl: any } }
      ) {
        console.log(params);
        return params.data.attachFileUrl
          ? h(
              'a',
              {
                attrs: {
                  href: params.data.attachFileUrl,
                  target: '_blank'
                }
              },
              ['点击下载']
            )
          : '';
      }
    }
  ];

  async getDetail(depositId: string) {
    const res = await api.getDepositOfCashPageList({ depositId });
    const data = res.data;
    if (data) {
      const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
      if (datas.length) {
        this.detailModel = datas[0];
      }
    }
  }

  get tableColums() {
    return [
      {
        title: '序号',
        width: 80,
        customRender: (text: any, record: any, index: number) => {
          if (record.isTotal === true) {
            return '合计';
          }
          return `${(this.current - 1) * this.pageSize + index + 1}`;
        }
      },

      {
        title: '费用类型',
        dataIndex: 'bizType'
      },
      {
        title: '支付方式',
        dataIndex: 'payMethod'
      },
      {
        title: '金额',
        dataIndex: 'paidPrice',
        customRender: this.numberRender
      },
      {
        title: '缴款人',
        dataIndex: 'payer'
      },
      {
        title: '收款人',
        dataIndex: 'payee'
      },
      {
        title: '交易时间',
        dataIndex: 'tradeTime',
        width: 200
      },
      {
        title: '费用期间',
        dataIndex: 'tradeDay'
      }
    ];
  }

  current: number = 1;
  pageSize: number = 10;
  total: number = 0;
  tableData: any[] = [];
  tableLoading: boolean = false;

  async fetchTableData() {
    if (!this.detailModel.parkId) {
      return;
    }
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;

      const res = await api.getDepositDetailPageListById({
        depositId: this.depositId,
        page: this.current,
        pageSize: this.pageSize
      });

      const data = res.data;
      if (data) {
        const { pageSize = 0, currPage = 0, totalPage, totalNum = 0, datas = [], total } = data;
        this.total = Number(totalNum);
        this.tableData = datas;
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  private showSizeChangerChange(current: any, pageSize: any) {
    this.current = current;
    this.pageSize = pageSize;
    this.fetchTableData();
  }

  numberRender(value: number) {
    if (isNaN(value)) {
      return value;
    } else {
      const num = (value / 100).toFixed(2);
      return num.replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    }
  }

  // 提交
  submitInfo() {
    if (this.cancel && this.depositId) {
      if (this.cancelReason == '') {
        this.$message.error('请填写冲销原因');
        return;
      }
      api
        .cancelDepositOfCash({
          depositId: this.depositId,
          reason: this.cancelReason
        })
        .then((res: any) => {
          this.$message.success('冲销成功');
          this.goBack();
        })
        .catch((e: any) => {
          this.$message.error('系统异常');
        });
    }
  }

  async init() {
    if (this.$route.path.indexOf('cash-page/cancel') > 0) {
      this.cancel = true;
    }
    this.depositId = this.$route.params.id;
    await this.getDetail(this.depositId);
    await this.fetchTableData();
  }
  async created() {
    this.init();
  }

  activated(): void {
    this.init();
  }
}
